export const config = {
    // API_URI: "https://zoobbe-board.onrender.com",
    // API_URI: "https://api-qcqo.onrender.com",

    // API_URI: "https://zoobbe-beta.onrender.com",
    // API_URI: "https://api-v1.zoobbe.com",
    // REACT_APP_API_URI lets an isolated test/dev build point at a specific
    // backend (e.g. the Dockerized test stack) without code changes. Unset in
    // production/dev, so the host-based logic below is unchanged there.
    API_URI: process.env.REACT_APP_API_URI || (() => {
        const host = typeof window !== 'undefined' ? window.location.hostname : '';
        if (host === 'zoobbe.com') return 'https://api.zoobbe.com';
        if (host === 'zoobbe.dev') return 'https://api.zoobbe.dev';
        // Everything else (dev.zoobbe.com, white-label domains, localhost):
        // talk to the SAME origin, which nginx proxies to the backend (/v1,
        // /socket.io/, /yjs). Must be an ABSOLUTE origin — an empty string makes
        // the Yjs WebsocketProvider build an invalid WS URL, which is why the
        // page editor sat at "Reconnecting…" on dev.zoobbe.com.
        return typeof window !== 'undefined' ? window.location.origin : '';
    })(),

    DOMAIN: typeof window !== 'undefined' ? window.location.origin : "https://zoobbe.com",
    IS_BETA: false,
    GOOGLE_CLIENT_ID: "406057575099-sdgi2ncbh82rkh76h55uk76p3vfp5u4c.apps.googleusercontent.com",
    // GOOGLE_CLIENT_ID: "39531044046-0lrtdc7ojrq119nhg7fq14t8m27ae0so.apps.googleusercontent.com",
    GITHUB_CLIENT_ID: "Ov23liUzCyNVGc0d98nY", // Replace with actual GitHub OAuth App Client ID
    PUSH_NOTIFICATION_VAPID_KEY_PAIR_ID: "BGeuQBwitmUXTSwhzhDt3xihBHyLDYSOZPXa7AXuIHWvK_7nv6bHM3WDDdlg_nMABtjigrQuOUN1iqmJtOcywkY",
    CLOUDFLARE_RECAPTCHA_SITE_KEY: "0x4AAAAAABCKhHsMLzF3gBUs",
    TRELLO_AUTH_API_KEY: "952269ee902bbd2a413c4890094365f2",
    STRIPE_PUBLIC_KEY: "pk_test_51Ldmn6K0cSs6yAeTLETj2DdPhCbbWMGy9lPEbMFF6POU8DODiJjMCEJgLrMfmN7WD3k96KkDs7nkQWK5UDPQANFp00aRx7H5Pn",
    FREE_COLLABORATORS_LIMIT: 15,
    APP_VERSION: "v1.0.10",
    // API_URI: "https://api.zoobbe.com",

    // Payment provider first-paint default ('stripe' | 'paddle'). The backend
    // (/v1/paddle/config) is the source of truth; this only avoids a flash
    // before that resolves. We only support Paddle right now, so default to it
    // (falling back to Stripe on a failed config fetch would render a broken
    // Stripe card form that errors on pay).
    PAYMENT_PROVIDER: 'paddle',

    // White Label Configuration
    DISABLE_WHITE_LABEL_PAYMENTS: false,

    // Global OAuth Configuration (for main Zoobbe domain)
    ENABLE_GOOGLE_AUTH: true, // Default: enabled for main Zoobbe domain
    ENABLE_GITHUB_AUTH: true, // Default: enabled for main Zoobbe domain
};
